import React from "react";

import CommunityPage from "../../components/community/CommunityPage";
import { removeExt } from "@/utils/image";
import { getJsonLd } from "@/lib/jsonLdUtils";

const Community = ({ community, articles }) => {
    //console.log("result", community);
    return (
        <div className="">
            <CommunityPage community={community} articles={articles} />
        </div>
    );
};

export const getServerSideProps = async (context) => {
    const server = process.env.LOCAL_SERVER;
    const { nameId } = context.params;

    // Guard against broken links like /community/undefined
    if (!nameId || nameId === "undefined" || nameId === "null") {
        return { notFound: true };
    }

    const res = await fetch(`${server}/api/community/${nameId}`);
    const community = await res.json();

    // The API returns {} when no matching community exists
    if (!community || !community.nameId) {
        return { notFound: true };
    }

    const res2 = await fetch(`${server}/api/article`);
    const articles = await res2.json();

    const { cpNumber, imageUrl, description, jsonLd } = getJsonLd(community);

    return {
        props: {
            community,
            articles,
            meta: {
                title:
                    community.name + " | Purple Door" + (cpNumber ? " | #" + cpNumber : ""),
                description,
                jsonLd,
                ogTitle: community.name + " | Purple Door",
                ogImage: imageUrl ? removeExt(imageUrl) + ".md.webp" : null,
                ogType: "profile",
            },
        },
    };
};

export default Community;
